<template>
  <div class="space-y-2">
    <h3 class="text-left text-ontick-carbon-900 dark:text-gray-300">
      {{ title }}
    </h3>
    <div class="box-shadow overflow-hidden rounded-lg">
      <table class="min-w-full">
        <thead class="bg-ontick-steel-100 text-ontick-carbon-900 dark:bg-ontick-steel-500 dark:text-gray-300">
          <tr>
            <th class="th">Estratégia</th>
            <th class="th">Resultado</th>
          </tr>
        </thead>
        <tbody class="bg-gray-50 py-4 dark:bg-ontick-graphite-500">
          <template v-if="loading">
            <tr>
              <td colspan="2">
                <placeholder-card-component :qtd="1" />
              </td>
            </tr>
          </template>
          <template v-else-if="visibility">
            <tr class="text-center" v-for="(item, index) in data" :key="index">
              <td class="whitespace-no-wrap px-3 py-2 text-sm text-ontick-carbon-900 dark:text-gray-300 md:px-6">
                {{ item.investment_name }}
              </td>
              <td
                class="whitespace-no-wrap px-2 py-2 text-sm"
                :class="positive ? 'text-ontick-green-600' : 'text-ontick-red-600'"
              >
                {{ item.total_profit | currency }}
              </td>
            </tr>

            <tr v-if="data.length == 0">
              <td colspan="2" class="mx-2 py-10 text-center text-ontick-steel-900 dark:text-gray-300 xl:text-lg">
                Nenhuma estratégia
              </td>
            </tr>
          </template>
          <tr v-else>
            <td colspan="2" class="mx-6 py-10 text-center text-lg italic text-ontick-steel-900 dark:text-gray-300">
              Dados ocultos
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
    },
    title: {
      type: String,
    },
    visibility: {
      type: Boolean,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    positive: {
      type: Boolean,
    },
  },

  components: {
    PlaceholderCardComponent: () => import("../../../shared/components/placeholder/placeholder-card.component.vue"),
  },
};
</script>

<style>
.th {
  @apply px-6 py-3 text-sm font-semibold uppercase  leading-4  text-ontick-carbon-900 dark:text-gray-300;
}
</style>
